import { SerializePayload } from 'app/area/search-filters/types';
import { filterId } from './constants';
import { ExternalUrlGroupsSearchModel } from './types-store';

const serializeQuery = (query: string) =>
  query?.trim().length
    ? {
      [filterId.query]: {
        text: query.trim()
      }
    }
    : {};

export const serialize = (payload: SerializePayload): ExternalUrlGroupsSearchModel => serializeQuery(payload.query);
